import React, { useEffect, useState } from "react";
import Layout from "./components/Layout";
import axios from "axios";
import { AppContext } from "./model/AppContext";
import { ElasticSearchResult } from "./model/ElasticSearchResult";

const endpoint = process.env.REACT_APP_ENDPOINT || ``;
const key = process.env.REACT_APP_KEY || ``;

const defaultQueryParams = {
  size: 16,
  "q.options": {
    defaultOperator: "or",
    fields: ["name", "sku"],
  },
  sort: "_score desc",
  "facet.brand": { sort: "bucket", size: 20 },
  "facet.categories": { sort: "bucket", size: 20 },
  return: "id,name,sku,brand,categories,images,item_url,default_price",
};

const afterpay = {
  payments: 4,
  logoUrl: "//assets.netostatic.com/assets/neto-cdn/afterpay/ap-01.jpg",
};
export const appContext = React.createContext<AppContext>({
  searching: false,
} as AppContext);

const params = {
  from: 0,
  size: 12,
  aggs: {
    brand: {
      terms: {
        field: "brand",
        size: 20,
        order: {
          _key: "asc",
        },
      },
    },
    categories: {
      terms: {
        field: "categories",
        size: 20,
        order: {
          _key: "asc",
        },
      },
    },
  },
  _source: [
    "id",
    "name",
    "sku",
    "brand",
    "categories",
    "images.ThumbURL",
    "item_url",
    "default_price",
  ],
};

const getSorting = (sort?: string) => {
  if (!sort) {
    return false;
  }

  const values = (sort as string).split(" ");
  if (values[0] === "default_price") {
    return {
      sort: [
        {
          default_price: {
            order: values[1],
            numeric_type: "double",
          },
        },
      ],
    };
  } else {
    return {
      sort: [
        {
          [values[0]]: {
            order: values[1],
          },
        },
      ],
    };
  }
};

function App() {
  const [query, setQuery] = useState<string | undefined>("");
  const [result, setResult] = useState<ElasticSearchResult | undefined>(
    {} as ElasticSearchResult
  );
  const [sort, setSort] = useState<any>("_score desc");
  const [category, setCategory] = useState<string | null>(null);
  const [searching, setSearching] = useState<boolean>(false);

  const getQueryInput = (input: HTMLElement | null) => {
    return input && (input as HTMLInputElement).value
      ? (input as HTMLInputElement).value.trim()
      : "";
  };

  useEffect(() => {
    const searchInputElement = document.getElementById("name_search");

    const keyupListener = (event: KeyboardEvent) => {
      event.preventDefault();
      updateContextQuery(getQueryInput(searchInputElement));
    };

    if (searchInputElement) {
      searchInputElement.addEventListener("keyup", keyupListener);
    }
  }, []);

  useEffect(() => {
    const fetchResult = async () => {
      setSearching(true);

      const filterCategory = {
        post_filter: {
          term: {
            categories: category,
          },
        },
      };

      const resp = await axios.post(
        endpoint,
        {
          ...params,
          query: {
            query_string: {
              query: `*${query}*`,
              fields: ["name", "sku"],
            },
          },
          ...(category && filterCategory),
          ...(sort && getSorting(sort)),
        },
        {
          headers: {
            "x-api-key": key,
          },
        }
      );
      const result = (await resp.data) as ElasticSearchResult;
      console.log(result);
      setSearching(false);
      updateContextResult(result);
    };
    if (query) {
      fetchResult();
    }
  }, [query, sort, category]);

  const updateContextSort = (sort: any) => {
    setSort(sort);
  };

  const updateContextQuery = (query?: string) => {
    setQuery(query);
  };

  const updateContextResult = (result?: ElasticSearchResult) => {
    setResult(result);
  };

  const updateCategory = (category: string | null) => {
    setCategory(category);
  };

  return (
    <appContext.Provider
      value={{
        query,
        result,
        afterpay,
        sort,
        category,
        searching,
        setQuery: updateContextSort,
        setResult: updateContextResult,
        setSort: updateContextSort,
        updateCategory: updateCategory,
      }}
    >
      <Layout />
    </appContext.Provider>
  );
}

export default App;
